<h1 mat-dialog-title class="notification-title">{{ 'insights.administration.reports.delete.title' | translate }}</h1>
<div mat-dialog-content>
	<p class="mat-caption" style="margin-bottom: 20px">{{ 'insights.administration.reports.delete.subtitle' + (data[0].isDeleted ? 'permanent' : '') | translate }}</p>
	@for (item of data; track item) {
	<span class="mat-subtitle-2">
		{{ item.name }}
		<br />
	</span>
	}
</div>
<div mat-dialog-actions align="end" style="margin-top: 20px">
	<button mat-stroked-button (click)="onNoClick()" class="button-border-color">{{ 'insights.administration.reports.delete.cancelbtn' | translate }}</button>
	<button mat-flat-button color="primary" [mat-dialog-close]="data" cdkFocusInitial>{{ 'insights.administration.reports.delete.deletebtn' | translate }}</button>
</div>
